export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_3.15311ad2.jpg";